import React from 'react';
import { SalesLayout } from '@/components/SalesLayout';
import { MultiReportsProvider, useMultiReports } from './MultiReportsContext';
import { Header } from './components/Header';
import { TabNavigation } from './components/TabNavigation';
import { Filters } from './components/Filters';
import { DataTable } from './components/DataTable';
import { BulkEditModal } from './components/BulkEditModal';

function MultiReportsContent({ user, onLogout }) {
  const { loading } = useMultiReports();

  if (loading) {
    return (
      <SalesLayout user={user} onLogout={onLogout} title="Multi Reports">
        <div className="flex items-center justify-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        </div>
      </SalesLayout>
    );
  }

  return (
    <SalesLayout user={user} onLogout={onLogout} title="Multi Reports">
      <div className="space-y-4">
        <Header />
        <TabNavigation />
        <Filters />
        <DataTable />
      </div>
      <BulkEditModal />
    </SalesLayout>
  );
}

function MultiReports({ user, onLogout }) {
  return (
    <MultiReportsProvider>
      <MultiReportsContent user={user} onLogout={onLogout} />
    </MultiReportsProvider>
  );
}

export default MultiReports;
